/**
 * Version Manager for Cache Busting
 * Forces browser cache refresh on deployments
 */

// Generate a unique version based on build time
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || Date.now().toString();

/**
 * Check if app version has changed and force reload if needed
 * @param {string} appName - Unique name for the application (e.g., 'admin', 'app', 'hub')
 */
export function checkVersion(appName = 'hub') {
  const STORAGE_KEY = `motorpay_${appName}_version`;
  const currentVersion = APP_VERSION;
  const storedVersion = localStorage.getItem(STORAGE_KEY);

  if (storedVersion && storedVersion !== currentVersion) {
    console.log(
      `[VersionManager] Version changed from ${storedVersion} to ${currentVersion}. Clearing cache...`
    );

    // Clear all caches
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }

    // Clear local storage except auth data
    const authData = localStorage.getItem('auth');
    localStorage.clear();
    if (authData) {
      localStorage.setItem('auth', authData);
    }

    // Update version
    localStorage.setItem(STORAGE_KEY, currentVersion);

    // Force reload with cache-buster to ensure we get new index.html
    const url = new URL(window.location.href);
    url.searchParams.set('_v', currentVersion);
    window.location.replace(url.toString());
  } else if (!storedVersion) {
    // First visit
    localStorage.setItem(STORAGE_KEY, currentVersion);
  }
}

/**
 * Force a cache refresh manually
 */
export function forceCacheRefresh() {
  // Clear all caches
  if ('caches' in window) {
    caches.keys().then((names) => {
      names.forEach((name) => caches.delete(name));
    });
  }

  // Hard reload with cache bypass
  const url = new URL(window.location.href);
  url.searchParams.set('_v', Date.now().toString());
  window.location.replace(url.toString());
}

/**
 * Add cache-busting query param to URLs
 */
export function cacheBust(url) {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${APP_VERSION}`;
}
